"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemSplitKindEnum = void 0;
var ItemSplitKindEnum;
(function (ItemSplitKindEnum) {
    ItemSplitKindEnum["TIP"] = "tip";
})(ItemSplitKindEnum || (exports.ItemSplitKindEnum = ItemSplitKindEnum = {}));
